module.exports = {
  size:   [{signal: 'width'}, {signal: 'height'}],
  mid:    [{expr: 'width/2'}, {expr: 'height/2'}],
  extent: [
    {expr: '[-padding.left, -padding.top]'},
    {expr: '[width+padding.right, height+padding.bottom]'}
  ]
};


//////////////////
// WEBPACK FOOTER
// ./~/react-vega/~/vega/src/transforms/screen.js
// module id = 45
// module chunks = 0